(function () {
    'use strict';
    angular.module('SMART2').service('StickyElements',[ function () {

		var stickyElementsObj = [];

		this.get = function () {
			var stickyElementsHeight = 0;
			if (stickyElementsObj.length > 0) {
				angular.forEach(stickyElementsObj, function (value, key) {
					stickyElementsHeight = stickyElementsHeight + value.height();
				});
			}
			return {
				height: stickyElementsHeight,
				listOfElements: stickyElementsObj
			};
		}

		this.set = function (obj) {
			stickyElementsObj = obj;
		}
    }])
	.directive('stickyHeader', ['$window', 'StickyElements', function ($window, StickyElements) {
		return {
			restrict: 'A',
			scope: true,
			link: function ($scope, $elem, $attrs) {
				var $win = angular.element($window);
				var elem = $elem[0];

				$scope.scrollType = $attrs.scrollType;

				if ($scope.scrollType === "page") {
					$win.bind('scroll', function (e) {
						if (elem.offsetParent !== null) {
							var windowScrollTop = $win[0].scrollY || $win[0].pageYOffset;
							var elScrollTop = $(elem).offset().top;
							var elScrollTopOriginal = $(elem).offset().top;
							var stickyElementHeight = StickyElements.get().height;
							if (angular.isDefined(angular.element('.grid-fixed-container').height())) {
								stickyElementHeight = stickyElementHeight + angular.element('.grid-fixed-container').height();
							}
							if (angular.isDefined(angular.element('.alert-bar--fixed-to-nav').height())) {
								stickyElementHeight = stickyElementHeight + angular.element('.alert-bar--fixed-to-nav').height();
							}
							if (angular.isDefined(angular.element('.breadcrum-container').height())) {
								stickyElementHeight = stickyElementHeight + angular.element('.breadcrum-container').height();
							}

							var theadHgt = $(elem).find('thead').height();

							var tbodyHgt = $(elem).find('tbody').not('.dummyThead').height();
							var $dummyThead = $(elem).find('.dummyThead');

							if (windowScrollTop + stickyElementHeight > elScrollTop && windowScrollTop + stickyElementHeight < (elScrollTop + tbodyHgt)) {
								elScrollTopOriginal = elScrollTop;
								stickTableHeader(stickyElementHeight, $scope.scrollType);
								if (!$dummyThead.length)
									$("<tbody class='dummyThead'><tr><td style='height:" + theadHgt + "px'></td></tr></tbody>").insertAfter($(elem).find('thead'));
							} else {
								angular.element(elem.querySelectorAll('thead')).css({ 'display': '', 'top': '', 'position': '', 'background': '' });
								if ($dummyThead.length)
									$dummyThead.remove();
							}
						}
					});
				}

				function stickTableHeader(top, scrollType) {
					var topVal = top;
					// reset display styles so column widths are correct when measured below
					angular.element(elem.querySelectorAll('thead, tbody, tfoot')).css('display', '');

					// set widths of columns
					angular.forEach(elem.querySelectorAll('tr:first-child th'), function (thElem, i) {
						var tdElems = elem.querySelector('tbody tr:first-child td:nth-child(' + (i + 1) + ')');

						var columnWidth = tdElems ? tdElems.offsetWidth : thElem.offsetWidth;

						if (tdElems) {
							tdElems.style.width = columnWidth + 'px';
						}
						if (thElem) {
							thElem.style.width = columnWidth + 'px';
						}
					});

					angular.element(elem.querySelectorAll('thead')).css({ 'top': topVal, 'position': 'fixed', 'background': '#ffffff', 'z-index': '2' });

					angular.element(elem.querySelectorAll('tbody')).css({
						'height': 'inherit',
						'overflow': 'hidden'
					});
				}
			}
		};
	}]);
})();